import { useMutation } from '@tanstack/react-query';

import { getFunnelsData, setFunnelsData } from './getFunnels';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const changeFunnelsOrder = (funnelIds: string[], pageId: string) =>
  axios.put(`/funnels/order`, { funnelIds, pageId });

type ChangeFunnelsOrder = {
  pageId: string;
  config?: MutationConfig<typeof changeFunnelsOrder>;
};

export function useChangeFunnelsOrder({ config = {}, pageId }: ChangeFunnelsOrder) {
  return useMutation({
    ...config,
    onMutate: async (funnelIds) => {
      await queryClient.cancelQueries({ queryKey: ['funnels', pageId] });
      const funnelsData = getFunnelsData(pageId);
      if (funnelsData) {
        const updatedFunnels = funnelIds.map(
          (_id) => funnelsData.funnels.find((funnel) => funnel._id === _id)!
        );
        setFunnelsData(pageId, { funnels: updatedFunnels });
        return { previousFunnels: funnelsData.funnels };
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['funnels', pageId]);
    },
    onError: (_, __, context) => {
      if (context) {
        setFunnelsData(pageId, { funnels: context.previousFunnels });
      }
    },
    mutationFn: (funnelIds: string[]) => changeFunnelsOrder(funnelIds, pageId),
  });
}
